import { PublicLayout } from "../../components/shell/WebLayout";

/**
 * Allgemeine Seite für abgelaufene Links (13_oeffentlich/link-abgelaufen.html, Zustandsbibliothek „Abgelaufener Link“).
 * Text nach der Vorlage, aber neutral statt in Du-Form (Befund 13: vor allem Marken öffnen abgelaufene Links) und mit
 * englischer Zeile für internationale Marken; es werden keine Daten geladen und keine angezeigt.
 */
export function LinkAbgelaufen() {
  return (
    <PublicLayout>
      <title>Dieser Link ist abgelaufen. · CreatorOffice</title>
      <meta name="robots" content="noindex, nofollow" />
      <main id="main" className="auth-shell stack">
        <section className="centerform panel stack">
          <h1>Dieser Link ist abgelaufen.</h1>
          <p>Einen neuen Link erhalten Sie bei Ihrer Kontaktperson.</p>
          <p>Es werden keine Vertrags- oder Profildaten angezeigt.</p>
          <p lang="en" className="muted">This link has expired. Please ask your contact person for a new link. No contract or profile data is shown.</p>
        </section>
      </main>
    </PublicLayout>
  );
}
